import { apiClient } from "@/core/services/apiClient";

/**
 * Bingo API service. Thin wrapper around backend endpoints.
 * All routes live under /api/plugins/bingo/*.
 */

const P = "/plugins/bingo";

export const bingoApi = {
  // Special numbers
  getSpecialNumbers: () =>
    apiClient.get(`${P}/special-numbers`).then((r) => r.data),
  putSpecialNumbers: (numbers) =>
    apiClient.put(`${P}/special-numbers`, { numbers }).then((r) => r.data),

  // Games
  createSession: ({ mode, autoInterval }) =>
    apiClient
      .post(`${P}/games`, { mode, autoInterval })
      .then((r) => r.data),

  getActiveSession: () =>
    apiClient.get(`${P}/games/active`).then((r) => r.data),

  getSession: (id) => apiClient.get(`${P}/games/${id}`).then((r) => r.data),

  patchSession: (id, patch) =>
    apiClient.patch(`${P}/games/${id}`, patch).then((r) => r.data),
};
